import api from "../../infra/api";

class ServSolAcessoSolDec {
    async Inserir(dto) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolAcessoSolDec",
            data: JSON.stringify(dto)
        });
        
        return response.data;
    }

    async Editar(dto) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolAcessoSolDec/${dto.Id}`,
            data: JSON.stringify(dto.Declaracao)
        });

        return response.data;
    }

    async RecuperarSolicitacoesDeclaracoes (codigoSolicitacaoAcesso) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolAcessoSolDec/RecuperarSolicitacoesDeclaracoes/${codigoSolicitacaoAcesso}`
        });
        
        return response.data;
    }
}

export default new ServSolAcessoSolDec();